import { tv } from 'tailwind-variants';

const styles = tv({
  base: '',
  slots: {
    floatingButtonContainer: `
      fixed
      bottom-0
      left-0
      right-0
      z-50
      border-t
      border-t-gray-100
      bg-white
      p-2
    `,
  },
});

export default styles;
